import partnerClient from "../partnerClient";

const rows = (data) => {
  const payload = data?.data ?? data;
  if (Array.isArray(payload)) return payload;
  return payload?.content ?? [];
};

/** Offers the office is running right now, newest first. */
export const fetchPartnerOffers = async () => {
  const { data } = await partnerClient.get("/program/offers", { params: { page: 0, size: 20 } });
  return rows(data);
};

/** Every published offer, running ones first and then ended ones, one page at a time. */
export const fetchAllPartnerOffers = async ({ page = 0, size = 10 } = {}) => {
  const { data } = await partnerClient.get("/program/offers/all", { params: { page, size } });
  return data?.data ?? data;
};

/** One published offer, running or ended, with everything the office wrote about it. */
export const fetchPartnerOffer = async (offerId) => {
  const { data } = await partnerClient.get(`/program/offers/${offerId}`);
  return data?.data ?? data;
};

export const fetchPartnerFaqs = async () => {
  const { data } = await partnerClient.get("/program/faqs", { params: { page: 0, size: 100 } });
  return rows(data);
};
